import React from 'react';
import LogoAncona from '../assets/img/LogoAncona.png';
type ConfirmacionFinalProps = {
  nombreComercial?: string;
  onVolver?: () => void;
};

const ConfirmacionFinal: React.FC<ConfirmacionFinalProps> = ({ nombreComercial, onVolver }) => {
  const nombre = nombreComercial?.trim();
  const handleVolver = () => {
    if (onVolver) {
      onVolver();
      return;
    }
  };

  return (
    <div className="bg-background text-on-background font-body-md min-h-screen flex flex-col">
      <header className="flex items-center w-full px-4 h-16 bg-surface border-b border-outline-variant fixed top-0 z-50 justify-center">
        <img 
          src={LogoAncona }
          alt="Ancona Pro Logo" 
          className="h-10 w-auto object-contain" 
        />
      </header>

      <main className="flex-grow flex flex-col items-center justify-center px-container-margin py-xl relative overflow-hidden">
        <div className="absolute top-0 right-0 -z-10 opacity-5 pointer-events-none">
          <span className="material-symbols-outlined text-[300px]">speed</span>
        </div>

        <div className="w-full max-w-lg bg-surface border border-outline-variant rounded-xl shadow-lg p-lg text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-secondary" />

          <div className="mb-lg flex justify-center">
            <div className="w-24 h-24 rounded-full bg-green-100 flex items-center justify-center">
              <span
                className="material-symbols-outlined text-[56px] text-green-600"
                style={{ fontVariationSettings: '"FILL" 1' }}
              >
                check_circle
              </span>
            </div>
          </div>

          <h2 className="text-headline-lg font-headline-lg text-primary mb-md">
            ¡Gracias por tu preferencia{nombre ? `, ${nombre}` : ''}!
          </h2>

          <div className="space-y-lg">
            <p className="text-body-lg text-on-surface leading-relaxed">
              Tu solicitud para activar el programa{' '}
              <span className="font-bold text-primary">ANCONA PRO</span> ha sido recibida
              correctamente.
            </p>

            <div className="bg-surface-container-low rounded-lg p-md text-left border-l-4 border-primary">
              <div className="flex gap-md">
                <span className="material-symbols-outlined text-primary">schedule</span>
                <p className="text-body-md">
                  En un máximo de <span className="font-bold">3 días hábiles</span> tu beneficio
                  quedará activo.
                </p>
              </div>
            </div>

            <p className="text-body-md text-on-surface-variant">
              Uno de nuestros asesores podrá contactarte para brindarte atención y seguimiento
              personalizado. Gracias por formar parte de la familia Ancona Autopartes.
            </p>

            <div className="pt-md">
              <button
                type="button"
                onClick={handleVolver}
                className="w-full bg-primary text-on-primary font-label-bold py-md rounded-lg shadow-md hover:opacity-90 active:scale-95 transition-all uppercase tracking-wider"
              >
                Volver al inicio
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ConfirmacionFinal;
